import React, { Component } from "react";
import "../Styles/DesktopNav.css";

export class DesktopNav extends Component {
  displayName = this.name;

  render() {
    function myFunction() {
      var x = document.getElementById("myLinks");
      if (x.style.display === "block") {
        x.style.display = "none";
      } else {
        x.style.display = "block";
      }
    }

    return (
      <div>
        <div className="row nav-div desktop-nav">
          <div className="my-navbar">
            <a href="/">Home</a>
            <a href="/Classes">Class Schedule</a>
            <a href="/About">About Us</a>
            <a href="/Location">Location</a>
          </div>
        </div>

        <div className="topnav">
          <a href="" className="active">
            Menu
          </a>
          <div id="myLinks">
            <a href="/">Home</a>
            <a href="/Classes">Class Schedule</a>
            <a href="/About">About Us</a>
            <a href="/Location">Location</a>
          </div>
          <a
            href=""
            className="icon"
            onClick={(e) => {
              e.preventDefault();
              myFunction();
            }}
          >
            <i className="fa fa-bars"></i>
          </a>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DesktopNav.js